import {type PIXI} from '@colonist/pixi'
import {type UIGameManager} from '../UIGameManager.ts'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler.ts'
import {UIHoverActionController} from './UIHoverActionController.ts'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorShip} from '@colonist/game-mechanic-validators'
import {type MechanicPirateState, type MechanicShipState, TileEdgeDirection} from '@colonist/game-states'

export class UIShipHoverActionController extends UIHoverActionController {
    private readonly validatorShip: MechanicValidatorShip

    constructor(uiGameManager: UIGameManager, shipState: MechanicShipState, mechanicPirateState: MechanicPirateState | undefined) {
        super(uiGameManager)
        this.resources = getCardsForPiece(PieceTypes.Ship)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildShipSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileEdgeHoverAction(this)
        this.validatorShip = new MechanicValidatorShip(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, shipState, mechanicPirateState)
    }

    getBankActionAmount(index: number): number {
        const myPlayer = this.validatorShip.getShipPlayerState(this.uiGameManager.gameController.myColor)
        return myPlayer.bankShipAmount
    }

    protected updateState() {
        const useResources = true
        const canPlaceShip = this.validatorShip.canPlayerPlaceShip(this.uiGameManager.gameController.myColor, useResources)
        this.updateHoverLocations(canPlaceShip.validHoverLocations, canPlaceShip.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getShipForPlayer(this.uiGameManager.gameController.myColor, TileEdgeDirection.NorthWest)
    }
}
